import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { Page } from '../../../components/page/Page'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import { enums, routes } from '../../../constants'
import utils from '../../../utils/index'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { actions } from '../configuracaoPixAutomatico.actions'
import { ConfiguracaoPixAutomaticoList } from './ConfiguracaoPixAutomaticoList'
import { MultiSelect } from 'primereact/multiselect'
import _ from 'lodash'

const mapStateToProps = (state) => {
  return {
    showHideColumns: state.crudConfiguracaoPixAutomaticoState.showHideColumns,
    messages: state.crudConfiguracaoPixAutomaticoState.messages,
    columns: state.crudConfiguracaoPixAutomaticoState.columns,
    records: state.crudConfiguracaoPixAutomaticoState.records,
    isLoadingRecords: state.crudConfiguracaoPixAutomaticoState.isLoadingRecords,
    first: state.crudConfiguracaoPixAutomaticoState.index,
    rows: state.crudConfiguracaoPixAutomaticoState.max,
    totalRecords: state.crudConfiguracaoPixAutomaticoState.count,
    sortField: state.crudConfiguracaoPixAutomaticoState.sortField,
    order: state.crudConfiguracaoPixAutomaticoState.sortOrder,
    selectedFilters: state.crudConfiguracaoPixAutomaticoState.selectedFilters || {},
    filterValues: state.crudConfiguracaoPixAutomaticoState.filterValues || {},
    booleanFilter: state.crudConfiguracaoPixAutomaticoState.booleanFilter || {},
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.applyFilter(filterParams))
    },

    changeFilter: (column, e) => {
      const target = e.target
      let campo = column.fieldJoin ? column.fieldJoin : target.name

      if (['codigoPsp'].find((field) => field === target.name)) {
        dispatch(actions.setBooleanFilter(target.name, target.value))
      }

      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))

      setTimeout(() => {
        dispatch(actions.executeFilter(`/lottustech/configuracoesPixAutomatico/all`))
      }, 400)
    },
    setSelectedRecords: (e) => {
      dispatch(actions.setSelectedRecords(e))
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
    salvarState: (state, filters) => {
      dispatch(actions.saveState(state, filters))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    exportarDadosCSV: () => {
      dispatch(actions.exportCSV())
    },
  }
}

class ConfiguracaoPixAutomaticoListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.columnSelect = React.createRef()
    this.visaoRef = React.createRef()
    this.showHideColumns = []
    this.showDialogVisao = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  onColumnToggle(event) {
    listPageUtils.onColumnToggle(event, this)
  }

  onColReorder(e, colunasAtuais) {
    listPageUtils.onColumnReorder(e, colunasAtuais, this)
  }

  exportar(excel = true) {
    listPageUtils.onCsvExport(this.props.records, this, actions, excel)
  }

  salvarState = (dados, state) => {
    let arrayColumns = this.showHideColumns.map((col) => {
      return col.value
    })
    arrayColumns.forEach((col) => {
      col.relationships = col.relacionamento
      delete col.relacionamento
    })
    state['columns'] = arrayColumns
    state['menu'] = { id: 1, value: this.props.history.location.pathname }
    this.props.salvarState(state, dados.filters)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/novo`)
  }

  componentDidMount() {
    listPageUtils.componentDidMount(this)
  }

  componentDidUpdate(prevProps, prevState) {
    listPageUtils.componentDidUpdate(this, prevProps, prevState)
  }

  onPage = (e) => {
    listPageUtils.onPage(this, e)
  }

  onSort = (e) => {
    listPageUtils.onSort(this, e)
  }

  onSelectionChange = (e) => {
    this.props.setSelectedRecords(e.value)
  }

  buildHeader = () => {
    return <DefaultToolBar listPageContainer={this} title="Configurações Pix Automático" />
  }

  formatColumn = (rowData, column) => {
    const formatted = utils.format(rowData, column)
    if (formatted !== null) {
      return formatted
    }

    let value = rowData[column.field]
    if (value && typeof value === 'object') {
      if (value.value) {
        value = value.value
      } else if (value.id) {
        value = value.id
      } else {
        value = JSON.stringify(value)
      }
    }

    if (typeof value === 'object' && value !== null) {
      return String(value)
    }

    return value
  }

  oidTemplate = (rowData) => {
    return <Link to={`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/${rowData.oid}`}>{rowData.oid}</Link>
  }

  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  pspTemplate = (rowData, column) => {
    const raw = rowData?.[column.field]
    const pspId = typeof raw === 'object' ? raw?.id || raw?.codigo : raw
    return <div title={enums.CONVERTER_CODIGO_PSP[pspId]}>{enums.CONVERTER_CODIGO_PSP[pspId]}</div>
  }

  ambienteTemplate = (rowData, column) => {
    const raw = rowData?.[column.field]
    const ambienteId = typeof raw === 'object' ? raw?.id || raw?.codigo : raw
    return <div>{enums.CONVERTER_AMBIENTE_PIX_AUTOMATICO[ambienteId]}</div>
  }

  jornadaTemplate = (rowData, column) => {
    const raw = rowData?.[column.field]
    const jornadaId = typeof raw === 'object' ? raw?.id || raw?.codigo : raw
    return <div>{enums.CONVERTER_JORNADA_ATIVA[jornadaId]}</div>
  }

  pspFilter = (column) => {
    return (
      <MultiSelect
        style={{ width: '100%', minWidth: '10px' }}
        name={column.field}
        value={(this.props.booleanFilter && this.props.booleanFilter[column.field]) || []}
        options={this.getBooleanOptionsCodigoPsp()}
        onChange={(e) => {
          _.set(this.props.filterValues, [column.field, 'valor'], e.value)
          this.props.changeFilter(column, e)
        }}
      />
    )
  }

  getBooleanOptionsCodigoPsp = () => {
    return [...enums.CodigoPsp]
      .sort((a, b) => String(a.value).localeCompare(String(b.value), 'pt-BR', { sensitivity: 'base' }))
      .map((item) => {
        return { label: item.value, value: item.id }
      })
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false
      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
          />
        )
      } else if (col.field === 'codigoPsp') {
        return (
          <Column
            {...col}
            key={col.field}
            filterHeaderStyle={{ overflow: 'visible' }}
            sortField={col.columnSortField}
            body={this.pspTemplate}
            filterElement={this.pspFilter(col)}
          />
        )
      } else if (col.field === 'ambiente') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.ambienteTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
          />
        )
      } else if (col.field === 'jornadaAtiva') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.jornadaTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
          />
        )
      }
      return (
        <Column
          {...col}
          key={col.field}
          sortField={col.columnSortField}
          filterElement={this.fieldFilter(col)}
          body={this.formatColumn}
        />
      )
    })
  }

  buildContent = () => {
    return (
      <ConfiguracaoPixAutomaticoList
        {...this.props}
        onSelectionChange={this.onSelectionChange}
        dataTableRef={(el) => (this.dataTableRef = el)}
        onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={this.defineColumns()}
      />
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      // O LoadingSpinner abaixo so cobre a primeira montagem, quando ainda nao ha colunas.
      // Depois disso paginar/ordenar/filtrar refaz a consulta com a grade ja na tela: o
      // `loading` do Page vela so a grade, sem prender o menu nem a toolbar.
      return <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracaoPixAutomaticoListPageContainer)
